import * as React from 'react';
const SvgMaterials = (props) => (
  <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.806 79.42v19.354L34.903 122M118.129 38.774 34.903 50.387l7.742 29.032L122 63.936l-3.871-25.162Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M114.258 65.445V96.84L34.903 122V98.774M7.806 38.774l27.097 11.613-7.742 29.032L2 62l5.806-23.226ZM110.387 39.316V5.871A3.87 3.87 0 0 0 106.516 2H17.484a3.87 3.87 0 0 0-3.871 3.871v23.226M34.903 23.29v27.097"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M50.387 38.774V27.09a3.872 3.872 0 0 1 3.668-3.866l39.32-2.071a3.291 3.291 0 0 1 3.464 3.285v8.53"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgMaterials;
